import { render, staticRenderFns } from "./NovaUserGroupSelector.vue?vue&type=template&id=49c6334c&scoped=true&"
import script from "./NovaUserGroupSelector.vue?vue&type=script&lang=ts&"
export * from "./NovaUserGroupSelector.vue?vue&type=script&lang=ts&"
import style0 from "./NovaUserGroupSelector.vue?vue&type=style&index=0&id=49c6334c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6334c",
  null
  
)

export default component.exports